var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dialog',{staticClass:"virtual-keypad",class:['theme-' + _vm.theme, { 'visible': _vm.visible, 'fixed': _vm.fixed }]},[_c('div',{class:_vm.keyboardClass,attrs:{"disabled":_vm.disabled}})])
}
var staticRenderFns = []

export { render, staticRenderFns }